import React, { useState } from "react";
import "./offcanvas.css"; // Include your scoped CSS here
import { useEffect } from "react";
import httpRequest from "../utils/Http";
import moment from "moment";

const TrackingOffcanvas = ({ show, handleClose, trackingDocket }) => {
  const [trackingData, setTrackingData] = useState({});
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (trackingDocket) {
      (async () => {
        setLoading(true);
        const response = await httpRequest(
          "gettrackingtetails",
          { tracking_number: trackingDocket.tracking_number },
          "POST"
        );
        if (response.status && response.data) {
          setTrackingData(response.data);
          setLoading(false);
          //console.log(response.data)
        } else {
          setTrackingData({});
          setLoading(false);
        }
      })();
    } else {
      setTrackingData({});
    }
  }, [trackingDocket]);

  return (
    <>
      {trackingDocket.courier_name && (
        <div className="my-offcanvas">
          <div className={`offcanvas ${show ? "show" : ""}`}>
            <div className="offcanvas-header">
              <h5>
                {trackingDocket?.courier_name.toUpperCase()}:{" "}
                {trackingDocket?.tracking_number}
              </h5>
              <button className="btn btn-secondary" onClick={handleClose}>
                ×
              </button>
            </div>
            <div className="offcanvas-body">
              <div className="timeline timeline-inverse">
                {trackingData?.courier_tracking_events?.length ? (
                  <>
                    {trackingData?.courier_tracking_events.map((ev, idx) => (
                      <>
                         {idx !==0 && (
<div className="time-label"></div>
                         )}
                        
                        <div>
                          <i
                            className={`fas ${
                              ev.tracking_detail.toLowerCase() === "delivered"
                                ? "fa-check bg-success"
                                : ev.tracking_detail.toLowerCase() ===
                                  "out for delivery"
                                ? "fa-flag bg-warning"
                                : ev.tracking_detail.toLowerCase() ===
                                    "pending" ||
                                  ev.tracking_detail.toLowerCase() ===
                                    "Out for pickup"
                                ? "fa-file bg-info"
                                : "fa-truck bg-primary"
                            } `}
                          ></i>
                          <div className="timeline-item">
                          <div className="timeline-content">
                          <strong>{ev.tracking_detail}</strong>
                     <div>{moment(ev.checkpoint_date).format('MMM DD, YYYY [at] HH:mm')} – {ev.location}</div>
                   </div>
                          </div>
                     
                        </div>
                        
                        {/* <div className="timeline-item">
                          <span className="time">
                            <i className="far fa-clock" /> 11:15
                          </span>
                          <h3 className="timeline-header">
                            <a href="#">Abhay (Dyanora)</a> NEW Booking
                            REGISTERED
                          </h3>
                          <div className="timeline-body">
                            HDMI PORT NOT WORKING
                          </div>
                        </div> */}
                      </>
                    ))}
                    <div className="time-label"></div>
                <div>
                  <i className="far fa-clock bg-gray" />
                </div>
                  </>
                ) : (
                  <p>
                    {isLoading ? "....Loading" : "No tracking details found."}
                  </p>
                )}
                
              </div>
            </div>
          </div>
        </div>
      )}
    </>

    // <div className="my-offcanvas">
    //  {trackingDocket?.courier_name && (
    //     <div className={`offcanvas ${show ? 'show' : ''}`}>
    //     <div className="offcanvas-header">
    //       <h5>{trackingDocket?.courier_name.toUpperCase()}: {trackingDocket?.tracking_number}</h5>
    //       <button className='btn btn-secondary' onClick={handleClose}>×</button>
    //     </div>
    //     <div className="offcanvas-body">
    //       {trackingData?.courier_tracking_events?.length ? (
    //         <div className="timeline">
    //           {trackingData?.courier_tracking_events.map((ev, idx) => (
    //             <div className="timeline-item" key={idx}>

    //               <div className={`timeline-icon ${ev.tracking_detail.toLowerCase().replace(/\s+/g, '-')}`}>
    //                 <i className={`fas ${ev.tracking_detail.toLowerCase() === 'delivered' ?
    //                 'fa-check': ev.tracking_detail.toLowerCase() === 'out for delivery' ?
    //                 'fa-flag': (ev.tracking_detail.toLowerCase() === 'pending' || ev.tracking_detail.toLowerCase() === 'Out for pickup') ? 'fa-file': 'fa-truck' } `}></i>
    //               </div>
    //               <div className="timeline-content">
    //                 <strong>{ev.tracking_detail}</strong>
    //                 <div>{moment(ev.checkpoint_date).format('MMM DD, YYYY [at] HH:mm')} – {ev.location}</div>
    //               </div>

    //             </div>
    //           ))}
    //         </div>
    //       ) : (
    //         <p>{isLoading ? '....Loading': 'No tracking details found.'}</p>
    //       )}
    //     </div>
    //   </div>
    //  )}

    // </div>
  );
};

export default TrackingOffcanvas;
